import { HudPanel } from './hud-panel';

export function UnreachableScreen(props: { onRetry: () => void }) {
  return (
    <main class="flex min-h-screen items-center justify-center p-6">
      <HudPanel class="max-w-md text-center">
        <h1 class="hud-mono text-lg font-semibold uppercase tracking-[0.22em] text-ink">
          Can't reach the agent
        </h1>
        <p class="mt-4 text-sm text-muted">
          The agent may be offline. This will resume automatically when it's back.
        </p>
        <button type="button" onClick={props.onRetry} class="hud-btn mt-4">
          Retry now
        </button>
      </HudPanel>
    </main>
  );
}
